import * as React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { Filter, FilterTypes, DateSelectFilter } from './FilterTypes';

interface Props {
    filters: Array<Filter>;
}

interface SelectedFiltersState {
    filters: Filter[];
}

export default class SelectedFiltersComponent extends React.Component<Props, SelectedFiltersState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            filters: this.props.filters,
        };
    }

    filterComponent(filter: Filter) {
        if (!filter.isSelected) {
            return null;
        }
        switch (filter.type) {
            case FilterTypes.select:
                return (
                    <div key={filter.name}>
                        {filter.label}: {_.upperFirst(filter.value as string)}
                    </div>
                );
            case FilterTypes.multiselect:
                return (
                    <div key={filter.name}>
                        {filter.label}:{' '}
                        {(filter.value as Array<{ label: string }>)
                            .map((selectObject) => _.upperFirst(selectObject.label))
                            .toString()}
                    </div>
                );
            case FilterTypes.text:
                if (filter.value === '') {
                    return null;
                }
                return (
                    <div key={filter.name}>
                        {filter.label}:{' '}
                        {(filter.value as string)
                            .split(',')
                            .map((val) => _.upperFirst(val))
                            .toString()}
                    </div>
                );
            case FilterTypes.date:
                const start = filter.dateRange.startDate
                    ? moment((filter as DateSelectFilter).dateRange.startDate).format('YYYY-MM-DD')
                    : 'Beginning';
                const end = moment((filter as DateSelectFilter).dateRange.endDate).format('YYYY-MM-DD');
                const label = start + ' - ' + end;
                return (
                    <div key={filter.name}>
                        {filter.label}: {label}
                    </div>
                );
        }
    }

    render() {
        return (
            <div>
                <form className="wfp-form--stacked filters-form" onSubmit={(e) => e.preventDefault()}>
                    {this.state.filters.map((filter) => {
                        return this.filterComponent(filter);
                    })}
                </form>
            </div>
        );
    }
}
